import { render, staticRenderFns } from "./GatewayDetail.vue?vue&type=template&id=22c8cc7c&scoped=true"
import script from "./GatewayDetail.vue?vue&type=script&lang=ts"
export * from "./GatewayDetail.vue?vue&type=script&lang=ts"
import style0 from "./GatewayDetail.vue?vue&type=style&index=0&id=22c8cc7c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c8cc7c",
  null
  
)

export default component.exports